import { Injectable } from '@angular/core';

import { RestService } from './rest.service';

import { environment } from '../../../environments/environment';

interface AupState {
  refUserAcceptedVersion: number;
  currentVersion: number;
}

@Injectable()
export class AupService {
  private cache: AupState = null;

  constructor(private readonly rest: RestService) {}

  // This - along with `cache` - is used to encourage the user to accept the current version of the UAP, without
  // requiring a new auth guard
  getState(forceRefresh: boolean = false): Promise<any> {
    if (!forceRefresh && this.cache) {
      // This mimics the data structure of an API response using `ResponseBuilder`
      return Promise.resolve({
        data: this.cache,
        err: false,
        msg: null,
      });
    }

    return this.rest.get(`${environment.apiUrl}/api/core/aup/ref`).then((res) => {
      if (res && res.data) {
        this.cache = res.data;
      }

      return res;
    });
  }

  acceptCurrentVersion(): Promise<any> {
    return this.rest.post(`${environment.apiUrl}/api/core/aup/accept`, {}).then((res) => {
      if (res && res.data) {
        this.cache = res.data;
      }

      return res;
    });
  }

  clearCache(): void {
    this.cache = null;
  }
}
